<template>
    <div id="overlay-spinner" :class="{'d-none': !isLoading}">
        <FadeLoader :loading="isLoading" :color="color" :height="height" :width="width"/>
    </div>
</template>

<script>
    import FadeLoader from "@/components/base/FadeLoader"
    import {createNamespacedHelpers} from 'vuex'

    const {mapState: mapLoadingState} = createNamespacedHelpers("axios");
    export default {
        name: "Spinner",
        components: {FadeLoader},
        data() {
            return {
                color: '#1e8cbf',
                height: '16px',
                width: '4px',
            };
        },
        computed: {
            ...mapLoadingState({
                isLoading: state => state.isLoading
            })
        },
    }
</script>

<style scoped>
    #overlay-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 99999999;
    }
</style>
